import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import {
  INemsisCustomElementsGroups,
  ISingleStateCustomElement,
  IStateCustomDataDisplayState,
} from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'
import { randomNumber } from '../../../utilities'

const getLastGroup = (groups: INemsisCustomElementsGroups, groupId: string | null, groupKey: string): number => {
  let lastGroupInstanceIndex = 0
  groups.forEach((group, i) => {
    if (group.groupId === groupId && group.groupKey === groupKey) {
      lastGroupInstanceIndex = i
    }
  })

  return lastGroupInstanceIndex
}

export function* duplicateGroup() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)

    const { state, groupId, stateCustomElements, groupKey } = customDisplayData

    const updatedStateCustomElements = stateCustomElements.map((stateElements: ISingleStateCustomElement) => {
      if (state !== stateElements.state) {
        return stateElements
      } else {
        const latestInstanceIndex = getLastGroup(stateElements.groups, groupId, groupKey)
        const newGroup = stateElements.groups[latestInstanceIndex]
        const filterCustomElementsToRemoveDuplicated = newGroup?.customElements.filter(
          (customEle) => !customEle.isDuplicated
        )
        const newGroupWithoutResults = {
          ...newGroup,
          groupingSequence: newGroup.groupingSequence + 1,
          groupKey: randomNumber().toString(),
          customElements: filterCustomElementsToRemoveDuplicated.map((customElement) => {
            const { results, resultsPNNV, ...rest } = customElement
            return { ...rest, _pnnvToggle: false, key: randomNumber().toString() }
          }),
        }

        const updatedGroups = [
          ...stateElements.groups.slice(0, latestInstanceIndex + 1),
          newGroupWithoutResults,
          ...stateElements.groups.slice(latestInstanceIndex + 1),
        ]

        return {
          ...stateElements,
          groups: updatedGroups,
        }
      }
    })
    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (e) {
    yield put(throwPcrException(`duplicateGroup() error: ${e}`))
  }
}

export function* duplicateGroupSaga() {
  yield takeLatest([StateCustomDataConstants.DUPLICATE_GROUP], performWithMutexHOG, duplicateGroup)
}
